import WorkLocation from "./Container"

export default WorkLocation
